import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.spaceRecord.DOC}
  query SpaceRecord(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecord(id: $spaceRecordId) {
                  ...FragmentSpaceRecord
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.SpaceRecordQuery,
  ents.extra.space.Record | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'space',
            graphql.transformers.OUT.select(
              'spaceRecord',
              fragments.spaceRecord.TRANSFORMER,
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordQuery,
  ents.extra.space.Record | undefined,
  graphql.schema.SpaceRecordQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
